import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ButtonWrapper from "../../../components/Button";
import InputWrapper from "../../../layout/inputWrapper";
import {
  ConstructionTypeOptions,
  natureOfCompounding,
  natureOfConstructionOptions,
  planOnOptions,
  projectTypeOptions,
  specialProjectOptions,
  yesOrNo,
} from "../../../../TCPForms/data";
import { Col, Container, Row } from "react-bootstrap";
import { Toast } from "@egovernments/digit-ui-react-components";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import { Checkbox, FormControlLabel } from "@mui/material";
import DxfFileUploader from "../../../reusableComponents/DxfFileUploader";
import { useHistory } from "react-router-dom";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import { set } from "lodash";
import useScrutinyProcess from "../../../../TCPForms/hooks/useScrutinyProcess";

const SubStep1 = ({ formData, handleSubTabChange, userInfo, handleTabChange, setProposedSite, schemeTypeData, nonSchemeTypeData, id }) => {
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1");

  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const [, scrutinyFlow, ScrutinySelector] = useScrutinyProcess();
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();

  const designType = formData?.proposalType;
  const defaultValues = {
    ...formData,
    fastPASId: formData?.fastPASId,
    proposalType: formData?.proposalType,
    isSpecialProject: formData?.isSpecialProject,
    groundCoverages: formData?.groundCoverages,
    fars: formData?.fars,
    buildingHeight: formData?.buildingHeight,
    previousSetbackFront: formData?.setbackFronts,
    previousSetbackRear: formData?.setbackRears,
    natureOfConstructionOptions: formData?.natureOfConstructionOptions,
  };

  const { handleSubmit, control, setValue, watch, reset, getValues, register } = useForm({ defaultValues });
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  const [fastPASData, setFastPasData] = useState(null);
  const [purchasableData, setPurchasableData] = useState(null);
  const [user, setUser] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const { data, isLoading: isDropDataLoading } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && data?.MapSubmission?.DropdownsConfig?.[0];
  const [schemeType, setSchemeType] = useState(false);
  const [declarationChecked, setDeclarationChecked] = useState(false);

  const [
    watchProposalType,
    watchisSpecialProject,
    watchTypeOfProject,
    watchPlotSubdivided,
    watchNeedComp,
    watchplotLeaseHold,
    watchisRevised,
    watchNoOfPLots,
    watchisApprovedLayout,
    watchisSetbackRequired,
    watchPlanOn,
    watchSpecialGroundCoverage,
    watchisSpecialFAR,
    watchProjectType,
    watchnatureOfConstruction,
    watchbuildingClassification,
    watchlandUseType,
    watchSubZoneType,
    watchPrimaryUse,
    watchAtivityProposed,
    watchSectorNo,
    watchLandMark,
    watchKhasraNo,
    watchTehsil,
    watchCompunding,
    watchisAncestralProperty,
    watchRevenueVillage,
    watchPlotNumbers,
    watchNoticeNumber,
  ] = watch([
    "proposalType",
    "isSpecialProject",
    "typeOfProject",
    "plotSubdivided",
    "needCompounding",
    "plotLeaseHold",
    "isRevised",
    "noOfPlots",
    "isApprovedLayout",
    "isSetbackRequired",
    "planOn",
    "isSpecialGroundCoverage",
    "isSpecialFAR",
    "projectType",
    "natureOfConstruction",
    "buildingClassification",
    "zoneType",
    "subZoneType",
    "primaryUse",
    "activityProposed",
    "sectorNo",
    "landMark",
    "khasraNo",
    "tehsil",
    "serviceType",
    "isAncestralProperty",
    "revenueVillage",
    "plotNumbers",
    "vaadId",
  ]);
  const watchedFields = watch();
  const mappedPlot = formData?.plotNumbers?.length;
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const isSelfCert =
    watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
    watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const isCompounding = watchnatureOfConstruction === "Compounding";
  // Calculate the number of full rows (each with 5 plots) and any remaining plots
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;

  // Generate an array representing the plot inputs
  const plotInputs = Array.from({ length: totalPlots }, (_, index) => ({
    index: index + 1,
  }));
  const plotNumbers = plotInputs.map((plot) => watchedFields[`plotNumbers[${plot.index}]`]);
  useEffect(() => {
    if (formData) {
      reset({
        ...formData,
        fastPASId: formData?.fastPASId,
        natureOfConstructionOptions: formData?.natureOfConstructionOptions,
        proposalType: formData?.proposalType,
        isSpecialProject: formData?.isSpecialProject,
        groundCoverages: formData?.groundCoverages,
        fars: formData?.fars,
        buildingHeight: formData?.buildingHeight,
        previousSetbackFront: formData?.setbackFronts,
        previousSetbackRear: formData?.setbackRears,
        prevFileNo: formData?.applicationNo,
      });
    }
  }, [formData]);

  useEffect(() => {
    console.log(watchPlotNumbers, "watchPlotNumbersssss");
    // setValue("plotNumbers", watchPlotNumbers);
  }, [watchPlotNumbers]);

  useEffect(() => {
    if (watchnatureOfConstruction === "Revalidation/Time Extension") {
      history.push(`mapRevalidation`);
    }
    if (watchnatureOfConstruction === "Group Housing") {
      history.push(`groupHousingPortal`);
    }
  }, [watchnatureOfConstruction]);

  useEffect(() => {
    //setProposedSite(watchPlanOn);
    const riskType =
      watchPlanOn ===
        ("Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
          watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm")
        ? "Building Plan Low Risk, Self Certification Mode"
        : (watchlandUseType === "Residential" || watchSubZoneType === "Residential") &&
          watchAtivityProposed !== "Row Houses" &&
          watchAtivityProposed !== "Semi Detached" &&
          watchAtivityProposed !== "Detached"
          ? "High Risk and High Nivesh"
          : watchlandUseType === "Commercial"
            ? "High Risk and High Nivesh"
            : watchPlanOn !== "Others"
              ? "Building Plan-Low Risk"
              : "Others";

    setRiskType(riskType);
    const buildClass = riskType === "Building Plan Low Risk, Self Certification Mode" ? "Building Plan-Low Risk" : riskType;
    if (watchPlanOn) {
      setValue("buildingClassification", buildClass);
    }
    if (
      watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
      watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"
    ) {
      setValue("noOfPlots", 1);
      setValue("natureOfConstruction", "New");
    }
    // if (watchPlanOn !== "Self Certification of residential Plot Area upto 300 SqM on approved layouts") {
    //   setValue("noOfPlots", null);
    //   setValue("natureOfConstruction", null);
    // }
  }, [watchPlanOn]);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const handleSearchClick = async (applicationNo) => {
    try {
      let response;
      let data;
      let purchasableData;
      if (applicationNo) {
        response = await Digit.OBPSService.BPAFastPASSearch({ land_Id: applicationNo });
        if (response?.BPA?.length === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`,
          });
          return;
        } else if (response?.BPA?.[0]?.department !== applicationFlow) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`,
          });
          return;
        }
        data = response?.BPA?.filter((item) => item.applicationType === "FORM_LANDUSE")?.[0];
        purchasableData = response?.BPA?.filter((item) => item.applicationType === "FORM_PURCHASABLE_FAR")?.[0];
        if (data) {
          const uuid = userInfo?.uuid;
          if (uuid) {
            const usersResponse = await Digit.UserService.userSearch(stateId, { uuid: [uuid] }, {});
            const userDetail = usersResponse?.user?.[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            if (data?.additionalDetails?.professionalInformation?.mobileNumber === userDetail?.mobileNumber) {
              setShowToast({
                key: "true",
                error: false,
                message: `Data fetched Successfully...!!`,
              });
            } else if (userDetail?.mobileNumber === data?.landInfo?.owners?.[0]?.mobileNumber) {
              setShowToast({
                key: "true",
                error: true,
                message: `Owner's mobile number and LTP's mobile number can't be same`,
              });
              return;
            } else {
              setShowToast({
                key: "true",
                error: true,
                message: `Not Authorized to access this Id...!!`,
              });
              return;
            }
          }
        }
        Digit.SessionStorage.set("FASTPAS_ID", data);
        setFastPasData(data);
        setPurchasableData(purchasableData);
        setValue("zoneType", data?.descriptionOfLand?.landUsesType);
        setValue("primaryUse", data?.descriptionOfLand?.activityAsPerMap);
        setValue("landMark", data?.descriptionOfLand?.landMark);
        setValue("sectorNo", data?.descriptionOfLand?.sectorNo);
        setValue("khasraNo", data?.descriptionOfLand?.khasraWithArea[0]?.khasraNo);
        setValue("schemeName", data?.descriptionOfLand?.schemeName);
        setValue("planOn", data?.descriptionOfLand?.planOn);
        setValue("riskType", data?.riskType);
        setValue("activityProposed", data?.descriptionOfLand?.activityProposed);
        setValue("plotArea", data?.descriptionOfLand?.landArea);
        setValue("plotAreaDoc", data?.descriptionOfLand?.plotAreaDoc);
        setValue("plotAreaPos", data?.descriptionOfLand?.plotAreaPossession);
        setValue("siteAddress", data?.descriptionOfLand?.landAddress);
        setValue("tehsil", data?.landInfo?.owners?.[0]?.permanentAddress?.tehsil);
        setValue("typeOfArea", data?.descriptionOfLand?.developmentArea);
        setValue("subZoneType", data?.descriptionOfLand?.subLandUseAsPerLayout);
        setValue("applicationType", "FORM_COMPOUNDING");
        // setValue("landInfo.owners", data?.landInfo?.owners);
        const isApproved = data?.descriptionOfLand?.schemeType === "Scheme";
        const plotArea = data?.descriptionOfLand?.landArea;
        setRiskType(data?.riskType);
        setSchemeType(isApproved);
        // if (isApproved) {
        // }
        if (isCompounding) {
          setValue("planOn", "FORM_MAP_COMPOUNDING");
        }
        if (!isApproved) {
          setValue("planOn", "Others");
          setValue("khasraNo", data?.khasraDetails?.reduce((acc, curr) => acc + curr?.khasraNumber + ",", "").slice(0, -1));
          setValue("tehsil", data?.khasraDetails?.[0]?.tehsil);
          setValue("revenueVillage", data?.khasraDetails?.[0]?.villageName);
        }
        if (plotArea > 40000) {
          setValue("shelterFee", "no");
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const filterSchemeData = (authority, masterData, category, subCategory) => {
    // First, find the relevant data once and store it
    const authorityData = masterData?.find((item) => item.name === authority);

    if (!authorityData) return { landUseList: [], landSubUseList: null }; // Return early if no authority data is found

    // Calculate landUseList, which doesn't depend on category
    const landUseList =
      authorityData?.LandUse?.map((item) => ({
        name: item.Type,
        value: item.Type,
      })) || []; // Fallback to an empty array if no LandUse is found

    let landSubUseList = null;

    // Only calculate landSubUseList if category is provided
    if (category) {
      const landUseCategory = authorityData?.LandUse?.find((item) => item.Type === category);

      // Only process if the specific category is found
      if (landUseCategory) {
        landSubUseList =
          landUseCategory.LandSubUse?.map((item) => ({
            name: item,
            label: item,
          })) || []; // Fallback to empty array if LandSubUse is not found
      }
    }

    console.log("loggingMasterData", landUseList, landSubUseList);

    return { landUseList, landSubUseList };
  };

  // const filterNonSchemeData = (authority, masterData, category, subCategory) => {
  //     const landUseList = masterData
  //         ?.filter((item) => item.name === authority)
  //         .map((item) => item.LandUse)
  //         .flat()
  //         .map((item) => {
  //             return { name: item.Type, value: item.Type };
  //         });

  //     const landSubUseList = masterData
  //         ?.filter((item) => item.name === authority)?.[0]
  //         ?.LandUse?.filter((item) => item.Type === category)?.[0]
  //         ?.LandSubUse?.map((item) => {
  //             return {
  //                 name: item,
  //                 label: item,
  //             };
  //         });
  //     // ?.map((item) => {
  //     //   return { name: item, label: item };
  //     // });
  //     console.log("nonSchemList", landUseList, landSubUseList);
  //     return { landUseList, landSubUseList };
  // };

  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    console.log("FromNonschemeDataCalled", masterData, category);

    const landUseList = masterData?.[0]?.CategeryType?.map((item) => {
      return { name: item.Categery, label: item.Categery };
    });
    const landSubUseList = masterData?.[0]?.CategeryType?.filter((item) => item.Categery === category)?.[0]?.["Activity Proposed"]?.map((item) => {
      return { name: item, label: item };
    });

    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return { landUseList, landSubUseList };
  };
  const { landUseList, landSubUseList } = !schemeType
    ? filterSchemeData(fastPASData?.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType)
    : filterNonSchemeData(fastPASData?.selectedOffice, nonSchemeTypeData, watchlandUseType, watchSubZoneType);
  console.log(schemeType, "schemeTypeerrrrr");
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };

  const onSubmit = (data) => {
    const fastPasdata = Digit.SessionStorage.get("FASTPAS_ID");
    if (!isSelfCert && !isCompounding && scrutinyFlow === "EDCR") {
      data.file = file;
    }
    if (isCompounding) {
      data.landInfo = fastPasdata?.landInfo;
      data.descriptionOfLand = fastPasdata?.descriptionOfLand;
      data.tenantId = stateId;
      data.land_Id = fastPasdata?.land_Id;
      data.documents = fastPasdata?.documents;
      data.descriptionOfLand = fastPasdata?.descriptionOfLand;
      data.nocDetails = fastPasdata?.nocDetails;
      data.occupancy = data?.zoneType;
      data.totalProposedArea = fastPASData?.descriptionOfLand?.landArea;
    }
    if (isSelfCert) {
      const newFormData = {
        landInfo: {
          ...fastPasdata?.landInfo,
        },
        tenantId: stateId,
        land_Id: fastPasdata?.land_Id,
        documents: fastPasdata?.documents,
        descriptionOfLand: fastPasdata?.descriptionOfLand,
        nocDetails: fastPasdata?.nocDetails,
        occupancy: data?.zoneType,
        totalProposedArea: fastPASData?.descriptionOfLand?.landArea,
      };
      data.selectedOffice = fastPASData?.additionalDetails?.selectedOffice || "";
      data.selectedCity = fastPASData?.additionalDetails?.selectedCity || "";
      data.landUseNo = fastPASData?.applicationNo;
      data.purchasableFAR = fastPASData?.descriptionOfLand?.properties?.[0]?.requiredAreaFAR || 0;
      data.land_Id = fastPasdata?.land_Id;
      data.department = fastPASData?.department;
      (data.plotArea = fastPASData?.descriptionOfLand?.landArea), (data = { ...data, ...newFormData });
    }
    if (!id && scrutinyFlow !== "EDCR") {
      // (data.plotNumbers = plotNumbers),
      data.applicantName = fastPASData?.landInfo?.owners?.[0]?.name || "";
      data.applicantEmailId = fastPASData?.landInfo?.owners?.[0]?.emailId || "";
      data.aplicantMobileNumber = fastPASData?.landInfo?.owners?.[0]?.mobileNumber || "";
      data.selectedOffice = applicationFlow === "DA" ? fastPASData?.additionalDetails?.selectedOffice : "UPAVP";
      data.selectedCity = fastPASData?.additionalDetails?.selectedCity || "";
      data.landUseNo = fastPASData?.applicationNo;
      data.department = fastPASData?.department;
      // data.purchasableFAR = purchasableData?.descriptionOfLand?.properties?.[0]?.requiredAreaFAR || 0;
      data.land_Id = fastPasdata?.land_Id;
      data.signatureId = fastPASData?.documents?.filter((doc) => doc.documentType === "signature")[0]?.fileStoreId || null;
      (data.licenseeName = user?.name), (data.licenseeLicenceNumber = user?.registrationNumber);
      data.licenseeMobileNumber = user?.mobileNumber;
      data.licenseeEmailId = user?.emailId;
      data.licenseeAddress = user?.correspondenceAddress?.address;
      data.scrutinyFlow = "PDF";
    }
    if (id) {
      handleSubTabChange(1, formData);
    }

    isSelfCert || isCompounding || scrutinyFlow !== "EDCR" ? handleTabChange(1, data) : handleSubTabChange(1, data);
  };
  if (applicationFlow === null) {
    return <DepartmentSelector />;
  }
  if (scrutinyFlow === null) {
    return <ScrutinySelector />;
  }

  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          {watchPlanOn && (
            <div className="formHeaderContainer">
              <h4 className="formHeading" style={{ background: "#f2f2f2", textAlign: "end", fontSize: "20px", color: "green" }}>
                {t(`${riskType === "Others" ? "High Risk and High Nivesh" : riskType}`)}
              </h4>
            </div>
          )}
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Application Form")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Nature of Construction /Case Type")}
                  placeholder={t("Select Nature Of Construction")}
                  name="natureOfConstruction"
                  defaultValue={formData?.natureOfConstruction}
                  data={SortingAlphabatically(natureOfConstructionOptions)}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isSelfCert}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label="FASTPAS ID"
                  placeholder="Enter FASTPAS ID."
                  name="fastPASId"
                  type="textInput"
                  mandatory
                  defaultValue={formData?.fastPASId}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  showSearchIcon={true}
                  onSearchClick={() => handleSearchClick(getValues("fastPASId"))}
                />
              </Col>
              {/* <Col></Col> */}
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landUseList)}
                  label={t("Land Use")}
                  placeholder={t("Select Type of Land")}
                  name="zoneType"
                  defaultValue={formData?.zoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchlandUseType}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landSubUseList)}
                  label={t("Land Sub Use")}
                  placeholder={t("Select Type of Land Subuse")}
                  name="subZoneType"
                  defaultValue={formData?.descriptionOfLand?.subLandUseAsPerLayout || formData?.subZoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={schemeType && watchSubZoneType}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landUseList)}
                  label={t("Primary Use of Proposed Activity")}
                  placeholder={t("Select Primary Use of Proposed Activity")}
                  name="primaryUse"
                  defaultValue={formData?.primaryUse}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchPrimaryUse}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landSubUseList)}
                  label={t("Activity proposed")}
                  placeholder={t("Select Type of Activity proposed")}
                  name="activityProposed"
                  defaultValue={formData?.activityProposed}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchAtivityProposed}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {" "}
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(planOnOptions)}
                  label={t("Proposed Site")}
                  placeholder={t("Proposed Site")}
                  name="planOn"
                  defaultValue={formData?.planOn}
                  type="selectInput"
                  mandatory={schemeType}
                  validation={{
                    required: {
                      value: schemeType,
                      message: "This field is required",
                    },
                  }}
                //disabled={!schemeType}
                />
              </Col>
              {watchPlanOn === "Others" ? (
                <Col>
                  <InputWrapper
                    label={"Other Proposed Site"}
                    control={control}
                    placeholder={t("Enter Proposed Site")}
                    name="otherSchemeName"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.otherSchemeName}
                    type="textInput"
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  label={t("Layout Sanction No.")}
                  control={control}
                  placeholder={t("Enter layout sanction number")}
                  name="layoutsanctionNumber"
                  defaultValue={formData?.layoutsanctionNumber}
                  type="textInput"
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Layout Sanction Date")}
                  control={control}
                  placeholder={t("Enter Layout Sanction date")}
                  name="layoutsanctionDate"
                  defaultValue={formData?.layoutsanctionDate}
                  type="datePicker"
                />
              </Col>
            </Row>
            <Row>
              {watchPlanOn === "Others" ? (
                <Col>
                  <InputWrapper
                    label={t("Development Area")}
                    control={control}
                    placeholder={t("Select Development Area Type")}
                    data={SortingAlphabatically(ConstructionTypeOptions)}
                    name="constructionType"
                    mandatory
                    defaultValue={formData?.constructionType}
                    type="selectInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
              <Col></Col>
            </Row>
            <Row>
              {watchnatureOfConstruction &&
                watchnatureOfConstruction !== "New" &&
                watchnatureOfConstruction !== "Compounding" &&
                watchnatureOfConstruction !== "Group Housing" ? (
                <Col>
                  <InputWrapper
                    label={t("Prev File No")}
                    control={control}
                    placeholder={t("Enter File No")}
                    name="prevFileNo"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    maxLength={15}
                    defaultValue={formData?.applicationNo}
                    type="textInput"
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
              {watchnatureOfConstruction === "Compounding" ? (
                <Col>
                  <InputWrapper
                    label={t("DM Circle Rate (In Rs. Per Square meter)")}
                    control={control}
                    placeholder={t("Enter DM Rate")}
                    name="dmCircleRate"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    containerStyles={{ lineHeight: "11px" }}
                    customLabelStyles={{ lineHeight: "11px" }}
                    defaultValue={formData?.dmCircleRate}
                    type="textInput"
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            <Row>
              <Col>
                {schemeType && (
                  <InputWrapper
                    label="Scheme Name"
                    control={control}
                    placeholder="Select Scheme Name"
                    defaultValue={formData?.schemeName}
                    name={`schemeName`}
                    type="selectInput"
                    mandatory
                    data={SortingAlphabatically(dropDownData?.schemeName)}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={fastPASData?.descriptionOfLand?.schemeName}
                  />
                )}
              </Col>
              {/* <InputWrapper
                                control={control}
                                data={updistricts}
                                label={t("District")}
                                placeholder={t("Select District")}
                                defaultValue={formData?.district}
                                name={`district`}
                                type="selectInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                }}
                            /> */}
              <Col>
                {" "}
                <InputWrapper
                  label={t("Tehsil")}
                  control={control}
                  placeholder={t("Enter Tehsil")}
                  name="tehsil"
                  defaultValue={formData?.tehsil}
                  type="textInput"
                  //disabled={!!watchTehsil}
                  validation={{
                    required: {
                      value: !schemeType,
                      message: "This field is required",
                    },
                  }}
                  mandatory={!schemeType}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label="Revenue Village/Colony Name"
                  control={control}
                  placeholder="Enter Revenue Village"
                  defaultValue={formData?.revenueVillage}
                  name={`revenueVillage`}
                  //disabled={!!watchRevenueVillage}
                  type="textInput"
                  mandatory={!schemeType}
                  validation={{
                    required: {
                      value: !schemeType,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Land Mark")}
                  control={control}
                  placeholder={t("Enter Land Mark")}
                  name="landMark"
                  mandatory={!schemeType}
                  maxLength={15}
                  defaultValue={formData?.landMark}
                  type="textInput"
                  disabled={watchLandMark}
                  validation={{
                    required: {
                      value: !schemeType,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {schemeType && (
                  <InputWrapper
                    label={t("Sector/Pocket No.")}
                    control={control}
                    placeholder={t("Enter Sector/Pocket No.")}
                    name="sectorNo"
                    mandatory={!schemeType}
                    maxLength={15}
                    defaultValue={formData?.sectorNo}
                    type="textInput"
                    validation={{
                      required: {
                        value: !schemeType,
                        message: "This field is required",
                      },
                    }}
                  />
                )}
              </Col>
              <Col>
                <InputWrapper
                  label={t("Khasra No.")}
                  control={control}
                  placeholder={t("Enter Khasra No.")}
                  name="khasraNo"
                  mandatory={!schemeType}
                  maxLength={15}
                  defaultValue={formData?.khasraNo}
                  //disabled={watchKhasraNo}
                  type="textInput"
                  validation={{
                    required: {
                      value: !schemeType,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Standard Type Design")}`}
                  name="proposalType"
                  defaultValue={formData?.proposalType || designType}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              {schemeType ? (
                <Col>
                  <InputWrapper
                    label={t("Plot No")}
                    control={control}
                    placeholder={t("Enter Plot no")}
                    name="plotNo"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.plotNo || fastPASData?.descriptionOfLand?.plotNo}
                    type="textInput"
                    disabled={fastPASData?.descriptionOfLand?.plotNo || formData?.plotNo}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            <Row>
              {watchProposalType === "yes" && (
                <Col>
                  <InputWrapper
                    label={t("Sanction date of layout")}
                    control={control}
                    placeholder={t("Enter Sanction date Of layout")}
                    name="sanctionDate"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.sanctionDate}
                    type="datePicker"
                  />
                </Col>
              )}
              {watchProposalType === "yes" && (
                <Col>
                  <InputWrapper
                    label={t("Sanction number of layout")}
                    control={control}
                    placeholder={t("Enter Sanction number Of layout")}
                    name="sanctionNumber"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.sanctionNumber}
                    type="textInput"
                  />
                </Col>
              )}
            </Row>
            {/* No Of Plots mapping  */}
            {watchProposalType === "yes" && (
              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("No. Of Plots")}
                    control={control}
                    placeholder={t("Enter No. Of Plots")}
                    name="noOfPlots"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.noOfPlots}
                    type="textInput"
                  />
                </Col>
                <Col></Col>
              </Row>
            )}

            {watchProposalType === "yes" && (
              <React.Fragment>
                {/* Full rows */}
                {Array.from({ length: fullRows }).map((_, rowIndex) => (
                  <Row key={rowIndex}>
                    {Array.from({ length: 3 }).map((_, colIndex) => {
                      const plotIndex = rowIndex * 3 + colIndex;
                      console.log(plotIndex, "plotIndexxx");
                      return (
                        <Col key={`plot-${plotIndex}`}>
                          <InputWrapper
                            control={control}
                            placeholder={t("Enter Plot No")}
                            name={`plotNumbers.${plotIndex}`} // Use dot notation
                            mandatory
                            validation={{
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }}
                            hasLabel={false}
                            maxLength={15}
                            type="textInput"
                          />
                        </Col>
                      );
                    })}
                  </Row>
                ))}

                {/* Remaining plots */}
                {remainingPlots > 0 && (
                  <Row key={fullRows}>
                    {Array.from({ length: remainingPlots }).map((_, colIndex) => {
                      const plotIndex = fullRows * 3 + colIndex;
                      return (
                        <Col key={`plot-${plotIndex}`}>
                          <InputWrapper
                            control={control}
                            placeholder={t("Enter Plot No")}
                            name={`plotNumbers.${plotIndex}`} // Use dot notation
                            mandatory
                            validation={{
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }}
                            maxLength={15}
                            hasLabel={false}
                            type="textInput"
                          />
                        </Col>
                      );
                    })}
                  </Row>
                )}
              </React.Fragment>
            )}

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={watchPlanOn === "Others" ? projectTypeOptions.filter((e) => e.name !== "Building Permission-Low Risk") : projectTypeOptions}
                  label={`${t("Project Type")}`}
                  placeholder={"Select Project Type"}
                  name="buildingClassification"
                  defaultValue={formData?.buildingClassification}
                  type={watchPlanOn ? "textInput" : "selectInput"}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchPlanOn}
                />
              </Col>
              <Col>
                {watchbuildingClassification === "Others" && (
                  <Col>
                    <InputWrapper
                      label={t("Other Project")}
                      control={control}
                      placeholder={t("Enter  Name")}
                      name="otherbuildingClass"
                      mandatory
                      isRequired={true}
                      defaultValue={formData?.otherbuildingClass}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                )}
              </Col>
            </Row>

            {/* {watchnatureOfConstruction !== 'New' && <Row>
                            <Col><InputWrapper
                                control={control}
                                data={dropDownData?.yesOrNo}
                                label={t("Is Revised")}
                                placeholder={t("Is Revised")}
                                name="isRevised"
                                defaultValue={formData?.isRevised}
                                type="radioButton"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                }}
                            />
                            </Col>
                            {watchisRevised === 'yes' && <Col>
                                <InputWrapper
                                    label={t("Prev File No")}
                                    control={control}
                                    placeholder={t("Enter File No")}
                                    name="prevFileNo"
                                    mandatory
                                    maxLength={15}
                                    defaultValue={formData?.prevFileNo}
                                    type="textInput"
                                /></Col>
                            }
                        </Row>} */}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Special Project type")}`}
                  name="isSpecialProject"
                  defaultValue={formData?.isSpecialProject}
                  type="radioButton"
                  data={yesOrNo}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                {" "}
                {(watchlandUseType !== "Residential" || watchPrimaryUse !== "Residential") && (
                  <InputWrapper
                    control={control}
                    data={yesOrNo}
                    label={t("If Community Parking Provided")}
                    placeholder={t("Select Community Parking")}
                    name="communityParking"
                    defaultValue={formData?.communityParking}
                    type="selectInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                )}
              </Col>
            </Row>
            {watchisSpecialProject === "yes" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Special Condition of Project")}
                    control={control}
                    placeholder={t("Select Condition of Project")}
                    data={SortingAlphabatically(specialProjectOptions)}
                    name="projectType"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.projectType}
                    type="selectInput"
                  />
                </Col>
                {watchProjectType === "Other" ? (
                  <Col>
                    <InputWrapper
                      label={t("Other Project")}
                      control={control}
                      placeholder={t("Enter  Name")}
                      name="otherProjectName"
                      mandatory
                      defaultValue={formData?.otherProjectName}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                ) : (
                  <Col></Col>
                )}
              </Row>
            )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("Ground Coverage")}
                      placeholder={t("Enter Ground Coverage")}
                      name="groundCoverages"
                      defaultValue={formData?.groundCoverages || formData?.groundCoverage}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>

                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("FAR")}
                      placeholder={t("Enter FAR")}
                      name="fars"
                      defaultValue={formData?.fars || formData?.far}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("Building Height")}
                      placeholder={t("Enter Building Height")}
                      name="buildingHeight"
                      defaultValue={formData?.buildingHeight}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("Please specify if any other condition")}
                      placeholder={t("Enter condition")}
                      name="anyotherCondition"
                      defaultValue={formData?.anyotherCondition}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Front")}
                      control={control}
                      placeholder={t("Enter Front")}
                      name="previousSetbackFront"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackFront || formData?.setbackFronts}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                  <Col>
                    {" "}
                    <InputWrapper
                      label={t("Rear")}
                      control={control}
                      placeholder={t("Enter Rear")}
                      name="previousSetbackRear"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackRear || formData?.setbackRears}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Side Setback-1")}
                      control={control}
                      placeholder={t("Enter Side Setback-1")}
                      name="previousSetbackSide1"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackSide1 || formData?.setbackSide1}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                  <Col>
                    {" "}
                    <InputWrapper
                      label={t("Side Setback-2")}
                      control={control}
                      placeholder={t("Enter Side Setback-2")}
                      name="previousSetbackSide2"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackSide2 || formData?.setbackSide2}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
              )}
            {fastPASData && fastPASData?.descriptionOfLand?.landArea < 40000 && watchlandUseType !== "Residential" && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    data={yesOrNo}
                    label={`${t("Will You Pay Shelter Fee")}`}
                    name="shelterFee"
                    defaultValue={formData?.shelterFee}
                    type="radioButton"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}
            {/* Additional Detail */}

            <Row>
              {(watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
                watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && (
                  <Col>
                    <InputWrapper
                      label={t("Is Your Plot sub-division")}
                      control={control}
                      name="plotSubdivided"
                      mandatory
                      data={yesOrNo}
                      defaultValue={formData?.plotSubdivided}
                      type="radioButton"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                )}
            </Row>
            <Row>
              {watchPlotSubdivided === "no" && (
                <Col>
                  <InputWrapper
                    label={t("Does existing building require any compounding ?")}
                    control={control}
                    name="needCompounding"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.needCompounding}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
            </Row>
            <Row>
              {watchNeedComp === "no" && watchPlotSubdivided === "no" && (
                <Col>
                  <InputWrapper
                    label={t("Is your plot Lease hold ?")}
                    control={control}
                    name="plotLeaseHold"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.plotLeaseHold}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
              {/* {watchplotLeaseHold === "yes" && (
                <Col>
                  <FileUploader
                    label={"Noc For Lease Hold"}
                    control={control}
                    name="leaseholdNOC"
                    validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                    required
                    isMandatory
                    tab={1}
                  />
                </Col>
              )} */}
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("Do you want Purchasable FAR?")}
                  control={control}
                  name="plotLeaseHold"
                  mandatory
                  data={yesOrNo}
                  defaultValue={formData?.plotLeaseHold}
                  type="radioButton"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                {watchplotLeaseHold === "yes" && (
                  <InputWrapper
                    label={t("Basic FAR")}
                    control={control}
                    name="basicFAR"
                    mandatory
                    placeholder={t("Enter Basic FAR")}
                    defaultValue={formData?.basicFAR}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                )}
              </Col>
            </Row>
            {watchplotLeaseHold === "yes" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Purchasable FAR")}
                    control={control}
                    name="purchasableFAR"
                    mandatory
                    defaultValue={formData?.purchasableFAR}
                    type="textInput"
                    placeholder={t("Enter Purchasable FAR")}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("Premium FAR")}
                    control={control}
                    name="premiumFAR"
                    mandatory
                    defaultValue={formData?.premiumFAR}
                    type="textInput"
                    placeholder={t("Enter Premium FAR")}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )}
            {watchnatureOfConstruction === "Compounding" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Is building plan previously approved?")}
                    control={control}
                    name="serviceType"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.serviceType}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                {watchCompunding !== "no" && <Col></Col>}
                {watchCompunding === "no" && (
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("Nature of compounding")}
                      placeholder={t("Select Nature Of Compounding")}
                      name="isAncestralProperty"
                      defaultValue={formData?.isAncestralProperty}
                      data={SortingAlphabatically(natureOfCompounding)}
                      type="selectInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    // disabled={isSelfCert}
                    />
                  </Col>
                )}
              </Row>
            )}
            {watchCompunding === "no" && watchisAncestralProperty === "In response to notice" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Enter Notice Number")}
                    control={control}
                    placeholder={t("Notice Number  (Mandatory Field)")}
                    name="vaadId"
                    mandatory
                    maxLength={24}
                    defaultValue={formData?.vaadId}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}
            {/* {watchPlotSubdivided === "yes" 
            // || watchplotLeaseHold === "yes" 
            ? (
              <InfoBox>
                Not authorized for Self Certification Approval of Map <span>*</span>
              </InfoBox>
            ) : (
              watchNeedComp === "yes" && (
                <InfoBox>
                  Kindly apply on Compounding Module <span>*</span>
                </InfoBox>
              )
            )} */}
            <div className="formContainer bg-white">
              <FormControlLabel
                style={{ padding: "10px 15px" }}
                control={
                  <Checkbox
                    name="declaration"
                    control={control}
                    onChange={handleDeclarationChange}
                    rules={{ required: "You must agree to the terms and conditions" }}
                  />
                }
                label={
                  <span>
                    I hereby declare that all the layers and information provided in the drawing file are accurate to the best of my knowledge.
                    <br /> The EDCR Scrutiny Engine will run based on this provided data only. Any other drawing-specific layers or information
                    present in the file shall not be the responsibility of the EDCR Engine.
                  </span>
                }
              />
            </div>
          </Container>
        </div>

        {!isSelfCert && !isCompounding && scrutinyFlow === "EDCR" && (
          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Upload DXF File")}</h2>
            </div>
            <Container fluid className="formInputContainer common-app-form custom-upload new-custom-uploader">
              <Row>
                <DxfFileUploader
                  control={control}
                  name="file"
                  label="Upload Building Plan Drawing"
                  validationMsg="(dxf only and Max file Size 300 MB)"
                  isMandatory
                  required
                  tab={3}
                  setFile={setFile}
                  maxFiles={1}
                />
              </Row>
            </Container>
          </div>
        )}
        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="success"
              size="medium"
              label="Save"
              type="submit"
              sx={{ backgroundColor: "#157CB3" }}
              disabled={
                !declarationChecked ||
                watchPlotSubdivided === "yes" ||
                // watchplotLeaseHold === "yes"
                watchNeedComp === "yes"
              }
            />
          </div>
        </div>
      </form>
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </section>
  );
};

export default SubStep1;
